import { formatNumber, dateTimeFormatter } from "@talladega/helpers";
import { LocalDate, convert } from "@js-joda/core";
import { i18n } from "next-i18next";

const getDisplayCoverageLength = (
  term: number,
  kms: number,
  locale: string,
  termExpiryDate?: LocalDate | string
): string => {
  if (i18n == null) return "";

  let coverageLength: string;

  if (termExpiryDate) {
    coverageLength = i18n.t("purchase:expires_date_or_kms", {
      termExpiryDate: dateTimeFormatter(
        convert(LocalDate.parse(termExpiryDate.toString())).toDate(),
        locale || "en",
        "MMMM, YYYY"
      ),
      kms: formatNumber(kms, locale),
    });
  } else if (kms === 999999) {
    coverageLength = i18n.t("purchase:months_and_unlimited_kms", {
      months: term,
    });
  } else {
    coverageLength = i18n.t("purchase:months_or_kms", {
      months: term,
      kms: formatNumber(kms, locale),
    });
  }
  return coverageLength;
};

export default getDisplayCoverageLength;
